<template>
  <div>
    <app-user-side-menu :min-width="15"
      :fixed-menu="false">
      <aside class="menu"
        slot="side-menu">
        <div class="menu-label">
          <div class="columns is-gapless mb-2">
            <div class="column">
              <span class="title is-6"
                style="white-space: nowrap"> Username: {{ entityName }} </span>
            </div>
          </div>
        </div>
        <ul class="menu-list">
          <li>
            <router-link :to="{ name: routeTypes.UserDetail.name, params: { userId: $route.params.userId } }"
              active-class="is-active"
              :class="{ 'tooltip is-tooltip-danger is-tooltip-right' : $v.detailGroup.$error }"
              :data-tooltip="[ $v.detailGroup.$error ? 'Validation errors' : '' ]"
              exact>
              <span :class="{ 'has-badge-danger has-badge-small has-badge-rounded has-badge-offset2': $v.detailGroup.$error }"
                :data-badge="$v.detailGroup.$error ? '' : null">Details
              </span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: routeTypes.UserProfile.name, params: { userId: $route.params.userId } }"
              active-class="is-active"
              :class="{ 'tooltip is-tooltip-danger is-tooltip-right' : !validProfileGroup }"
              :data-tooltip="[ !validProfileGroup ? 'Validation errors' : '' ]"
              exact>
              <span :class="{ 'has-badge-danger has-badge-small has-badge-rounded has-badge-offset2': !validProfileGroup }"
                :data-badge="!validProfileGroup ? '' : null">User Profile</span>
            </router-link>
          </li>
          <li v-if="!isMobileAppUser">
            <router-link :to="{ name: routeTypes.UserAccessControl.name, params: { userId: $route.params.userId } }"
              active-class="is-active"
              :class="{ 'tooltip is-tooltip-danger is-tooltip-right' : $v.userAccessControl.$error }"
              :data-tooltip="[ $v.userAccessControl.$error ? 'Validation errors' : '' ]"
              exact>
              <span :class="{ 'has-badge-danger has-badge-small has-badge-rounded has-badge-offset2': $v.userAccessControl.$error }"
                :data-badge="$v.userAccessControl.$error ? '' : null">Access Control</span>
            </router-link>
          </li>
          <li v-if="!isMobileAppUser">
            <router-link :to="{ name: routeTypes.UserAccessRestriction.name, params: { userId: $route.params.userId } }"
              active-class="is-active"
              exact>
              <span><span class="has-badge-child-offset2">Access Restriction</span></span>
            </router-link>
          </li>
        </ul>
      </aside>
    </app-user-side-menu>
  </div>
</template>
<script>
import AppUserSideMenu from '../user/AppUserSideMenu.vue'
import UserRoutes from './route-types'
import SuperadminUsersRoutes from '../../views/superadmin/user/route-types.js'

export default {
  name: 'UserSideMenu',
  inject: ['$vv'],
  components: {
    AppUserSideMenu
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    entityName: {
      type: String,
      default: ''
    },
    isMobileAppUser: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    routeTypes() {
      if (this.$userInfo.isSystemAdministrator && !this.$userInfo.isSupportUser) {
        return SuperadminUsersRoutes
      } else return UserRoutes
    },
    validProfileGroup() {
      return !this.$v.profileAddressesGroup.$error && !this.$v.profileEmailsGroup.$error && !this.$v.profilePhonesGroup.$error
    }
  },
  methods: {}
}
</script>
